module.exports = __webpack_public_path__ + "static/media/spinnerGifc438f6bb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/spinnerGif.gif
// module id = 1423
// module chunks = 0